import { render, staticRenderFns } from "./AboutUsPromoSection.vue?vue&type=template&id=14a83fba&"
import script from "./AboutUsPromoSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsPromoSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPromoSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports